import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_ARBITRUM = [ChainId.ARBITRUM]
export const SUPPORT_ONLY_BSC = [ChainId.BSC]
export const SUPPORT_FARMS = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.ETHEREUM, ChainId.GOERLI]

export const SUPPORT_ZAP = [ChainId.BSC, ChainId.BSC_TESTNET]
